import Vue from 'vue';

function useComponents(components) {
    return Object.keys(components ?? {}).reduce((list, name) => {
        Vue.component(name, components[name]);
        list.push(name);

        return list;
    }, []);
}

export default (_app, _moduleName, moduleComponents) => ({
    global: useComponents(moduleComponents?.global),
    local: useComponents(moduleComponents?.local),
});
